

import { hasTerrain } from "./terrain.js"
import { pick3DTileset } from "./3DTileset"

//获取俩点空间距离
export function getSpace(point1, point2) {
    var distance = Cesium.Cartesian3.distance(point1, point2);
    return distance;
}

//获取距离文本描述
export function getDistanceText(distance) {
    distance = distance || 0;
    return distance.toFixed(2) > 1000 ? (distance / 1000).toFixed(2) + "公里" : distance.toFixed(2) + "米";
}

//求Rectangle范围内 按count等比插值的granularity值 
export function getGranularity(positions, count) {
    var recta = Cesium.Rectangle.fromCartesianArray(positions);
    var granularity = Math.max(recta.height, recta.width);
    granularity /= Cesium.defaultValue(count, 10); //默认分割10次
    return granularity;
}

/**
     * 获取坐标的贴地(或贴模型)高度
     * opts支持: 是否在has3dtiles:true , 是否异步 asyn:true  异步回调方法calback
     */
export function getSurfaceHeight(scene, position, opts) {
    opts = opts || {};

    //是否在3ditiles上面
    var has3dtiles = Cesium.defaultValue(opts.has3dtiles, Cesium.defined(pick3DTileset(scene, position)));
    if (has3dtiles) {
        //求贴模型的高度
        return getSurface3DTilesHeight(scene, position, opts);
    } else {
        //求贴地形高度
        return getSurfaceTerrainHeight(scene, position, opts);
    }
}

//路线进行贴地(或贴模型)插值, splitNum为次数 
function interPolyline(opts) {
    var positions = opts.positions;
    var scene = opts.scene;

    var granularity = getGranularity(positions, opts.splitNum || 100);
    if (granularity <= 0) granularity = null;

    var flatPositions = Cesium.PolylinePipeline.generateArc({
        positions: positions,
        height: opts.height, //未传入时，内部默认为0
        minDistance: opts.minDistance, //插值间隔(米)，优先级高于granularity
        granularity: granularity //splitNum分割的个数
    });

    var arr = [];
    for (var i = 0; i < flatPositions.length; i += 3) {
        var position = Cesium.Cartesian3.unpack(flatPositions, i);
        if (scene && Cesium.defaultValue(opts.surfaceHeight, true)) {
            var height = getSurfaceHeight(scene, position, opts);
            var car = Cesium.Cartographic.fromCartesian(position);
            position = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
        }
        arr.push(position);
    }
    return arr;
}

//计算贴地(或贴模型)路线（异步）
var surfaceLineWork = {
    start: function start(params) {
        this.params = params;
        this.scene = params.scene;

        var positions = params.positions;
        if (positions == null || positions.length == 0) {
            //无数据
            this.end(positions);
            return;
        }
        this.positions = positions;

        //线中间插值
        var _split = Cesium.defaultValue(params.split, true);
        if (_split) {
            positions = interPolyline({
                scene: this.scene,
                positions: positions,
                height: params.height,
                minDistance: params.minDistance,
                surfaceHeight: params.splitSurfaceHeight,
                splitNum: Cesium.defaultValue(params.splitNum, 100)
            });

            var positionsClone = [];
            for (var i = 0, len = positions.length; i < len; ++i) {
                positionsClone.push(positions[i].clone());
            }
            this.positions = positionsClone;
        }

        var _has3dtiles = Cesium.defaultValue(params.has3dtiles, Cesium.defined(pick3DTileset(this.scene, positions))); //是否在3ditiles上面
        var _hasTerrain = hasTerrain(this.scene); //是否有地形

        this._has3dtiles = _has3dtiles;
        this._hasTerrain = _hasTerrain;

        if (!_hasTerrain && !_has3dtiles) {
            //无地形和无模型时，直接返回
            this.end(positions);
            return;
        }

        //开始分析
        if (_hasTerrain) {
            this.clampToTerrain(positions);
        } else {
            this.clampTo3DTileset(positions);
        }
        return this;
    },
    clampToTerrain: function clampToTerrain(positions) {
        var ellipsoid = this.scene.globe.ellipsoid;
        var cartographicArray = ellipsoid.cartesianArrayToCartographicArray(positions);

        //用于缺少地形数据时，赋值的高度
        var tempHeight = Cesium.Cartographic.fromCartesian(positions[0]).height;

        var that = this;
        that.scene._terrainExaggeration = that.scene._terrainExaggeration || 1;
        Promise.resolve(Cesium.sampleTerrainMostDetailed(this.scene.terrainProvider, cartographicArray)).then(function (samples) {
            samples = that.removeNullData(samples);

            var noHeight = false;
            var offset = Cesium.defaultValue(that.params.offset, 0); //增高高度，便于可视

            for (var i = 0; i < samples.length; ++i) {
                if (samples[i].height == null) {
                    noHeight = true;
                    samples[i].height = tempHeight;
                } else {
                    samples[i].height = offset + samples[i].height * that.scene._terrainExaggeration;
                }
            }

            var raisedPositions = ellipsoid.cartographicArrayToCartesianArray(samples);

            if (that._has3dtiles) {
                that.clampTo3DTileset(raisedPositions);
            } else {
                that.end(raisedPositions, noHeight);
            }
        });
    },
    clampTo3DTileset: function clampTo3DTileset(positions) {
        var that = this;
        var positionsClone = [];
        for (var i = 0, len = positions.length; i < len; ++i) {
            positionsClone.push(positions[i].clone());
        }
        this.scene.clampToHeightMostDetailed(positionsClone).then(function (clampedCartesians) {
            clampedCartesians = that.removeNullData(clampedCartesians);
            if (clampedCartesians.length == 0) {
                clampedCartesians = positions;
            }
            that.end(clampedCartesians);
        });
    },
    end: function end(raisedPositions, noHeight) {
        if (this.params.calback) this.params.calback(raisedPositions, noHeight, this.positions);
    },
    removeNullData: function removeNullData(samples) {
        var arrNew = [];
        for (var i = 0; i < samples.length; ++i) {
            if (samples[i] != null) {
                arrNew.push(samples[i]);
            }
        }
        return arrNew;
    }
};


/**
* 获取坐标的 贴模型高度
* opts支持: 是否异步 asyn:true  异步回调方法calback返回“新高度”和“原始的Cartographic坐标”
*/
export function getSurface3DTilesHeight(scene, position, opts) {
    opts = opts || {};

    //原始的Cartographic坐标
    opts.cartesian = opts.cartesian || Cesium.Cartographic.fromCartesian(position);
    var carto = opts.cartesian;

    //是否异步求精确高度 
    if (opts.asyn) {
        scene.clampToHeightMostDetailed([position]).then(function (clampedPositions) {
            var clampedPt = clampedPositions[0];
            if (Cesium.defined(clampedPt)) {
                var cartiles = Cesium.Cartographic.fromCartesian(clampedPt);
                var heightTiles = cartiles.height;
                if (Cesium.defined(heightTiles) && heightTiles > -1000) {
                    if (opts.calback) opts.calback(heightTiles, cartiles);
                    return;
                }
            }
            //说明没在模型上，继续求地形上的高度
            getSurfaceTerrainHeight(scene, position, opts);
        });
    } else {
        //取贴模型高度
        var heightTiles = scene.sampleHeight(carto);
        if (Cesium.defined(heightTiles) && heightTiles > -1000) {
            if (opts.calback) opts.calback(heightTiles, carto);
            return heightTiles;
        }
    }

    return 0; //表示取值失败
}


/**
* 获取坐标的 贴地高度
* opts支持:   是否异步 asyn:true  异步回调方法calback
*/
function getSurfaceTerrainHeight(scene, position, opts) {
    opts = opts || {};

    //原始的Cartographic坐标
    var carto = opts.cartesian || Cesium.Cartographic.fromCartesian(position);

    var _hasTerrain = hasTerrain(scene); //是否有地形
    if (!_hasTerrain) {
        //不存在地形，直接返回
        if (opts.calback) opts.calback(carto.height, carto);
        return carto.height;
    }

    //是否异步求精确高度 
    if (opts.asyn) {
        Promise.resolve(Cesium.sampleTerrainMostDetailed(scene.terrainProvider, [carto])).then(function (samples) {
            var clampedCart = samples[0];
            var heightTerrain;
            if (Cesium.defined(clampedCart) && Cesium.defined(clampedCart.height)) {
                heightTerrain = clampedCart.height;
            } else {
                heightTerrain = scene.globe.getHeight(carto);
            }
            if (opts.calback) opts.calback(heightTerrain, carto);
        });
    } else {
        var heightTerrain = scene.globe.getHeight(carto);
        if (Cesium.defined(heightTerrain) && heightTerrain > -1000) {
            if (opts.calback) opts.calback(heightTerrain, carto);
            return heightTerrain;
        }
    }
    return 0; //表示取值失败
}


//计算贴地(或贴模型)路线（异步）
var surfaceLineWork = {
    start: function start(params) {
        this.params = params;
        this.scene = params.scene;

        var positions = params.positions;
        if (positions == null || positions.length == 0) {
            //无数据
            this.end(positions);
            return;
        }
        this.positions = positions;

        //线中间插值
        var _split = Cesium.defaultValue(params.split, true);
        if (_split) {
            positions = interPolyline({
                scene: this.scene,
                positions: positions,
                height: params.height,
                minDistance: params.minDistance,
                surfaceHeight: params.splitSurfaceHeight,
                splitNum: Cesium.defaultValue(params.splitNum, 100)
            });

            var positionsClone = [];
            for (var i = 0, len = positions.length; i < len; ++i) {
                positionsClone.push(positions[i].clone());
            }
            this.positions = positionsClone;
        }

        var _has3dtiles = Cesium.defaultValue(params.has3dtiles, Cesium.defined(pick3DTileset(this.scene, positions))); //是否在3ditiles上面
        var _hasTerrain = hasTerrain(this.scene); //是否有地形

        this._has3dtiles = _has3dtiles;
        this._hasTerrain = _hasTerrain;

        if (!_hasTerrain && !_has3dtiles) {
            //无地形和无模型时，直接返回
            this.end(positions);
            return;
        }

        //开始分析
        if (_hasTerrain) {
            this.clampToTerrain(positions);
        } else {
            this.clampTo3DTileset(positions);
        }
        return this;
    },
    clampToTerrain: function clampToTerrain(positions) {
        var ellipsoid = this.scene.globe.ellipsoid;
        var cartographicArray = ellipsoid.cartesianArrayToCartographicArray(positions);

        //用于缺少地形数据时，赋值的高度
        var tempHeight = Cesium.Cartographic.fromCartesian(positions[0]).height;

        var that = this;
        that.scene._terrainExaggeration = that.scene._terrainExaggeration || 1;
        Promise.resolve(Cesium.sampleTerrainMostDetailed(this.scene.terrainProvider, cartographicArray)).then(function (samples) {
            samples = that.removeNullData(samples);

            var noHeight = false;
            var offset = Cesium.defaultValue(that.params.offset, 0); //增高高度，便于可视

            for (var i = 0; i < samples.length; ++i) {
                if (samples[i].height == null) {
                    noHeight = true;
                    samples[i].height = tempHeight;
                } else {
                    samples[i].height = offset + samples[i].height * that.scene._terrainExaggeration;
                }
            }

            var raisedPositions = ellipsoid.cartographicArrayToCartesianArray(samples);

            if (that._has3dtiles) {
                that.clampTo3DTileset(raisedPositions);
            } else {
                that.end(raisedPositions, noHeight);
            }
        });
    },
    clampTo3DTileset: function clampTo3DTileset(positions) {
        var that = this;
        var positionsClone = [];
        for (var i = 0, len = positions.length; i < len; ++i) {
            positionsClone.push(positions[i].clone());
        }
        this.scene.clampToHeightMostDetailed(positionsClone).then(function (clampedCartesians) {
            clampedCartesians = that.removeNullData(clampedCartesians);
            if (clampedCartesians.length == 0) {
                clampedCartesians = positions;
            }
            that.end(clampedCartesians);
        });
    },
    end: function end(raisedPositions, noHeight) {
        if (this.params.calback) this.params.calback(raisedPositions, noHeight, this.positions);
    },
    removeNullData: function removeNullData(samples) {
        var arrNew = [];
        for (var i = 0; i < samples.length; ++i) {
            if (samples[i] != null) {
                arrNew.push(samples[i]);
            }
        }
        return arrNew;
    }
};

//对外接口,求路线的贴地线
export function computeSurfaceLine(params) {
    return surfaceLineWork.start(params);
}

//对外接口,求多个点的的贴地新坐标（不插值）
export function computeSurfacePoints(params) {
    params.split = false;
    return surfaceLineWork.start(params);
}

//对外接口,按2个坐标点分段计算 求路线的贴地线
function computeStepSurfaceLine(opts) {
    var positions = opts.positions;

    var params = {};
    for (var key in opts) {
        if (key == "positions" || key == "calback") continue;
        params[key] = opts[key];
    }

    var index = 0;
    var allcount = positions.length - 1;
    function getLineFD() {
        if (index >= allcount) {
            if (opts.calbak) opts.calbak();
            if (opts.calbakEnd) opts.calbakEnd();
            return;
        }

        params.positions = [positions[index], positions[index + 1]];
        params.calback = function (raisedPositions, noHeight) {
            opts.calbakStep(raisedPositions, noHeight, index);

            index++;
            getLineFD();
        };
        surfaceLineWork.start(params);
    }
    getLineFD();
}

/**
 * 计算曲线链路的点集（a点到b点的，空中曲线）
 * @param startPoint 开始节点
 * @param endPoint 结束节点
 * @param angularityFactor 曲率
 * @param numOfSingleLine 点集数量
 * @returns {Array}
 */
function getLinkedPointList(startPoint, endPoint, angularityFactor, numOfSingleLine) {
    var result = [];

    var startPosition = Cesium.Cartographic.fromCartesian(startPoint);
    var endPosition = Cesium.Cartographic.fromCartesian(endPoint);

    var startLon = startPosition.longitude * 180 / Math.PI;
    var startLat = startPosition.latitude * 180 / Math.PI;
    var endLon = endPosition.longitude * 180 / Math.PI;
    var endLat = endPosition.latitude * 180 / Math.PI;

    var dist = Math.sqrt((startLon - endLon) * (startLon - endLon) + (startLat - endLat) * (startLat - endLat));

    //var dist = Cesium.Cartesian3.distance(startPoint, endPoint);
    var angularity = dist * angularityFactor;

    var startVec = Cesium.Cartesian3.clone(startPoint);
    var endVec = Cesium.Cartesian3.clone(endPoint);

    var startLength = Cesium.Cartesian3.distance(startVec, Cesium.Cartesian3.ZERO);
    var endLength = Cesium.Cartesian3.distance(endVec, Cesium.Cartesian3.ZERO);

    Cesium.Cartesian3.normalize(startVec, startVec);
    Cesium.Cartesian3.normalize(endVec, endVec);

    if (Cesium.Cartesian3.distance(startVec, endVec) == 0) {
        return result;
    }

    //var cosOmega = Cesium.Cartesian3.dot(startVec, endVec);
    //var omega = Math.acos(cosOmega);

    var omega = Cesium.Cartesian3.angleBetween(startVec, endVec);

    result.push(startPoint);
    for (var i = 1; i < numOfSingleLine - 1; i++) {
        var t = i * 1.0 / (numOfSingleLine - 1);
        var invT = 1 - t;

        var startScalar = Math.sin(invT * omega) / Math.sin(omega);
        var endScalar = Math.sin(t * omega) / Math.sin(omega);

        var startScalarVec = Cesium.Cartesian3.multiplyByScalar(startVec, startScalar, new Cesium.Cartesian3());
        var endScalarVec = Cesium.Cartesian3.multiplyByScalar(endVec, endScalar, new Cesium.Cartesian3());

        var centerVec = Cesium.Cartesian3.add(startScalarVec, endScalarVec, new Cesium.Cartesian3());

        var ht = t * Math.PI;
        var centerLength = startLength * invT + endLength * t + Math.sin(ht) * angularity;
        centerVec = Cesium.Cartesian3.multiplyByScalar(centerVec, centerLength, centerVec);

        result.push(centerVec);
    }

    result.push(endPoint);

    return result;
}


//面内进行贴地(或贴模型)插值, 返回三角网等计算结果
export function interPolygon(opts) {
    var scene = opts.scene;

    //坐标数组
    var positions = [];
    var pos = opts.positions;
    for (var i = 0; i < pos.length; i++) {
        positions.push(pos[i].clone());
    }

    //splitNum分割的个数
    var granularity = getGranularity(positions, opts.splitNum);

    //插值求面的三角网   
    var arrPoly = [];

    var polygonGeometry = new Cesium.PolygonGeometry.fromPositions({
        positions: positions,
        vertexFormat: Cesium.PerInstanceColorAppearance.FLAT_VERTEX_FORMAT,
        granularity: granularity
    });
    var geom = new Cesium.PolygonGeometry.createGeometry(polygonGeometry);

    var i0, i1, i2;
    var cartesian1, cartesian2, cartesian3;
    for (var i = 0; i < geom.indices.length; i += 3) {
        i0 = geom.indices[i];
        i1 = geom.indices[i + 1];
        i2 = geom.indices[i + 2];

        //三角形 点1
        cartesian1 = new Cesium.Cartesian3(geom.attributes.position.values[i0 * 3], geom.attributes.position.values[i0 * 3 + 1], geom.attributes.position.values[i0 * 3 + 2]);
        arrPoly.push(cartesian1);

        //三角形 点2
        cartesian2 = new Cesium.Cartesian3(geom.attributes.position.values[i1 * 3], geom.attributes.position.values[i1 * 3 + 1], geom.attributes.position.values[i1 * 3 + 2]);
        arrPoly.push(cartesian2);

        //三角形 点3
        cartesian3 = new Cesium.Cartesian3(geom.attributes.position.values[i2 * 3], geom.attributes.position.values[i2 * 3 + 1], geom.attributes.position.values[i2 * 3 + 2]);
        arrPoly.push(cartesian3);
    }

    var maxHeight = 0;
    var minHeight = 9999;
    var onlyPoint = Cesium.defaultValue(opts.onlyPoint, false); //只返回点，不需要三角网时

    //格式化每个点
    function onFormatPoint(position, noHeight) {
        var height;
        var point;
        var pointDM;

        if (noHeight) {
            height = getSurfaceHeight(scene, position, opts);

            var carto = Cesium.Cartographic.fromCartesian(position);
            point = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude, 0);
            pointDM = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude, height);
        } else {
            var carto = Cesium.Cartographic.fromCartesian(position);
            var height = carto.height;

            point = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude, 0);
            pointDM = position;
        }

        if (maxHeight < height) maxHeight = height;
        if (minHeight > height) minHeight = height;

        return {
            height: height,
            point: point,
            pointDM: pointDM
        };
    }

    function interCalback(raisedPositions, noHeight) {
        var arrSJW = [];
        var obj1, obj2, obj3;
        for (var i = 0; i < raisedPositions.length; i += 3) {
            //三角形 点1 
            obj1 = onFormatPoint(raisedPositions[i], noHeight);
            //三角形 点2 
            obj2 = onFormatPoint(raisedPositions[i + 1], noHeight);
            //三角形 点3 
            obj3 = onFormatPoint(raisedPositions[i + 2], noHeight);

            if (onlyPoint) {
                //只返回点，不需要三角网
                addPointFoyArrOnly(arrSJW, obj1);
                addPointFoyArrOnly(arrSJW, obj2);
                addPointFoyArrOnly(arrSJW, obj3);
            } else {
                //常规返回，三角网
                arrSJW.push({
                    point1: obj1,
                    point2: obj2,
                    point3: obj3
                });
            }
        }

        if (Cesium.defined(opts.minHeight)) {
            minHeight = Math.max(opts.minHeight, minHeight);
            maxHeight = Math.max(maxHeight, minHeight);
        }

        var result = {
            granularity: granularity,
            maxHeight: maxHeight,
            minHeight: minHeight,
            list: arrSJW //三角网 
        };

        if (opts.calback) opts.calback(result);
        return result;
    }

    //是否异步求精确高度 
    if (opts.asyn) {
        //求高度 
        return computeSurfacePoints({
            scene: scene,
            positions: arrPoly,
            has3dtiles: opts.has3dtiles,
            calback: interCalback
        });
    } else {
        return interCalback(arrPoly, true);
    }
}

//计算三角形空间面积
export function getAreaOfTriangle(pos1, pos2, pos3) {
    var a = Cesium.Cartesian3.distance(pos1, pos2);
    var b = Cesium.Cartesian3.distance(pos2, pos3);
    var c = Cesium.Cartesian3.distance(pos3, pos1);
    var S = (a + b + c) / 2;
    return Math.sqrt(S * (S - a) * (S - b) * (S - c));
}


//获取圆（或椭圆）边线上的坐标点数组
export function getEllipseOuterPositions(opts) {
    var position = opts.position;
    if (!position) return null;

    var count = Cesium.defaultValue(opts.count, 1); //点的数量，总数为count*4
    var semiMajorAxis = Cesium.defaultValue(opts.semiMajorAxis, opts.radius);
    var semiMinorAxis = Cesium.defaultValue(opts.semiMinorAxis, opts.radius);
    var rotation = Cesium.defaultValue(opts.rotation, 0);

    //获取椭圆上的坐标点数组
    var cep = Cesium.EllipseGeometryLibrary.computeEllipsePositions({
        center: position,
        semiMajorAxis: semiMajorAxis, //长半轴
        semiMinorAxis: semiMinorAxis, //短半轴
        rotation: rotation,
        granularity: Math.PI / (16 * count)
    }, true, true);

    var arr = cep.outerPositions;
    var positions = [];
    for (var i = 0, len = arr.length; i < len; i += 3) {
        //长半轴上的坐标点
        var pt = new Cesium.Cartesian3(arr[i], arr[i + 1], arr[i + 2]);
        positions.push(pt);
    }
    return positions;
}
